import React, { useEffect, useState } from 'react';
import { DropDown, TextField, Checkbox } from 'cantarus-react-ui';
import { FieldDataStrings as Strings } from '../../../utils/config';
import * as templateSettingsApi from '../../../api/templateSettingsApi'
import Spinner from '../../common/Spinner'



const FieldDataPageSelector = ({ fieldKey, fieldName, fieldValue, handleFieldDataTextChange }) => {

    const [pages, setPages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isUrlExternal, setIsUrlExternal] = useState(true);

    let selectedOption = null
    const dropdownPlaceholder = pages.length === 0 ? Strings.noPagesPlaceholder : Strings.pagesPlaceholder;
    const dropdownOptions = pages.map(page => {
        const option = { value: page.Path, label: page.TabName }
        if (option.value === fieldValue) {
            selectedOption = option
        }
        return option
    });
    const fieldValueString = (typeof fieldValue === 'string') ? fieldValue : ''

    useEffect(() => {
        const fetchPages = async () => {
            const portalPages = await templateSettingsApi.getAllPageNamesAndUrls();
            setPages(portalPages);

        }
        setTimeout(() => setLoading(false), 1000);
        fetchPages();

    }, [])

    useEffect(() => {
        if (pages.find(page => page.Path === fieldValue)) {
            setIsUrlExternal(false)
        }
    }, [pages])

    const handleChange = (url) => {
        handleFieldDataTextChange(fieldName, url);
    }

    const handleExternalUrlChange = (data) => {
        handleFieldDataTextChange(fieldName, data.trim());
    }

    const toggleExternal = () => {

        // Clear value if toggling to internal url
        if (isUrlExternal) {
            handleChange('')
        }

        setIsUrlExternal(!isUrlExternal)
    }

    return (
        <div>
            {
                loading ?
                    <Spinner /> :
                    <div className='td-field-data-page-selector'>
                        <span className='td-field-data-page-selector-text'>{Strings.externalUrlText}</span>
                        <Checkbox value={isUrlExternal} onChange={toggleExternal} toggle />
                        <div className='td-field-data-page-selector-input'>
                            {
                                isUrlExternal &&
                                <TextField
                                    onChange={handleExternalUrlChange}
                                    value={fieldValueString}
                                    placeholder={Strings.placeholder} />
                            }
                            {!isUrlExternal &&

                                <DropDown
                                    onChange={(option) => handleChange(option.value)}
                                    placeholder={dropdownPlaceholder}
                                    disabled={pages.length === 0}
                                    options={dropdownOptions}
                                    selected={selectedOption}
                                    searchable
                                />
                            }
                        </div>
                    </div>
            }
        </div>
    );
}

export default FieldDataPageSelector;
